import { SETTINGS } from "./types"

const changePassword = (data, history) => ({
    type: SETTINGS.CHANGE_PASSWORD,
    payload: data,
    history
})

const changePin = (data, history) => ({
    type: SETTINGS.CHANGE_PIN,
    payload: data,
    history
})

const editProfile = (data, history) => ({
    type: SETTINGS.EDIT_PROFILE,
    payload: data,
    history
})

const resetEmail = data => ({
    type: SETTINGS.RESET_EMAIL,
    payload: data
})

const updateProfile = data => ({
    type: SETTINGS.UPDATE_PROFILE,
    payload: data
})

const updateProfileSuccess = data => ({
    type: SETTINGS.UPDATE_PROFILE_SUCCESS,
    payload: data
})


export {
    changePassword,
    changePin,
    editProfile,
    resetEmail,
    updateProfile,
    updateProfileSuccess,
}